import React from 'react';
import HttpsRedirect from 'react-https-redirect';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory as History } from 'history';
import './App.css';
import { Login, Dashboard, Deposit, Withdrawal, InternalTransfer, PaymentServices, Settings, Users, CurrencySettings, Profile, CustomerDocuments, RecoverPassword } from './views';
import { LanguageProvider, LanguageConsumer } from './contexts/Language';
import { AuthProvider, AuthRoute } from './contexts/Auth';
import { FetchLoading, AuthLoading } from './components/Loading';
import { Page404, Page500, Page401 } from './views/ErrorPages';
import { Rules } from './views/PaymentServices/Rules';
import { WhiteList } from './views/PaymentServices/WhiteList';
import { BlackList } from './views/PaymentServices/BlackList';
import { PageRole } from './views/PaymentServices/PageRole';
import { DailyLimit } from './views/PaymentServices/DailyLimit';
import './components/Utilities';
import UniPayment from './views/PaymentServices/UniPayment';
import { DepositDetail } from './views/PaymentServices/UniPayment/DepositDetail';

function App() {
  return (
    <HttpsRedirect>
      <Router history={History()}>
        <FetchLoading />
        <AuthLoading />
        <AuthProvider>
          <LanguageProvider>
            <LanguageConsumer>
              {() => (
                <Switch>
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/recoverpassword" component={RecoverPassword} />

                  {/* AUTH ROUTE */}
                  <AuthRoute exact path={['/dashboard', '/home', '/']} component={Dashboard} />

                  {/* MONEY TRANSFER */}
                  <AuthRoute exact path="/deposit" component={Deposit} />
                  <AuthRoute exact path="/withdrawal" component={Withdrawal} />
                  <AuthRoute exact path="/internal-transfer" component={InternalTransfer} />

                  {/* TRANSFER OPTIONS */}
                  <AuthRoute exact path="/payment-services" component={PaymentServices} />
                  <AuthRoute exact path="/rules" component={Rules} />
                  <AuthRoute exact path="/daily-limit" component={DailyLimit} />
                  <AuthRoute exact path="/white-list" component={WhiteList} />
                  <AuthRoute exact path="/black-list" component={BlackList} />
                  <AuthRoute exact path="/page-role" component={PageRole} />
                  <AuthRoute exact path="/payment-services/unipayment" component={UniPayment} />
                  <AuthRoute exact path="/payment-services/unipayment/deposit/:invoiceId" component={DepositDetail} />

                  {/* COMMON */}
                  <AuthRoute exact path="/customer-documents" component={CustomerDocuments} />
                  <AuthRoute exact path="/profile" component={Profile} />
                  <AuthRoute exact path="/users" component={Users} />
                  <AuthRoute exact path="/settings" component={Settings} />
                  <AuthRoute exact path="/currency-settings" component={CurrencySettings} />

                  {/* 404 */}
                  <Route exact path="/500" component={Page500} />
                  <Route exact path="/401" component={Page401} />
                  <Route component={Page404} />
                </Switch>
              )}
            </LanguageConsumer>
          </LanguageProvider>
        </AuthProvider>
      </Router>
    </HttpsRedirect>
  );
}

export default App;
